import { FieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import { breakpoint } from 'utility/constant';
import styles from './StateField.module.scss';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export const StateField = (props: FieldProps) => {
  const { label, value, isInColumn } = props;

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.sm }]);

  return (
    <div className={`${styles.fieldContainer} ${!isMobile && !isInColumn ? styles.marginBottom : ''}`}>
      {isMobile || isInColumn ? null : <p className={styles.betLabel}>{label}</p>}
      <p className={styles.betData}>{value}</p>
    </div>
  );
};